export default __webpack_public_path__ + "static/media/Croc3.ea4d7e36.png";